import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute Component
 * Controls access based on user role and authentication
 * 
 * @param {ReactNode} children - Component to render if authorized
 * @param {Array<string>} allowedRoles - Array of roles allowed to access this route
 * @param {string} redirectTo - Path to redirect if unauthorized (default: /admin/login)
 */
const ProtectedRoute = ({ children, allowedRoles = [], redirectTo = '/admin/login' }) => {
    const token = sessionStorage.getItem('token');
    const userRole = sessionStorage.getItem('userRole');

    // If no token, redirect to login
    if (!token) {
        return <Navigate to={redirectTo} replace />;
    }

    // If allowedRoles is empty, allow all authenticated users
    if (allowedRoles.length === 0) {
        return children;
    }

    // Check if user's role is in the allowed roles
    if (allowedRoles.includes(userRole)) {
        return children;
    }

    // If role doesn't match, redirect based on role
    if (userRole === 'reviewer') {
        return <Navigate to="/reviewer/dashboard" replace />;
    }

    // For other roles, redirect to admin dashboard
    return <Navigate to="/admin/dashboard" replace />;
};

export default ProtectedRoute;
